/* Wolfborn compact guest-list cart v3. Theme safeguards, not server validation. */
(function () {
  'use strict';
  function boot() {
    if(window.__WBPNCartV3||!window.WolfbornPlaceNames)return;
    const configEl=document.querySelector('[data-wbpn-cart-config]');if(!configEl)return;
    let cfg;try{cfg=JSON.parse(configEl.textContent);}catch(_){return;}
    window.__WBPNCartV3=true;
    const core=window.WolfbornPlaceNames,passes=new WeakSet();
    let cart=cfg.cart||{items:[]},busy=false,timer,lastError='';
    const checkouts='button[name="checkout"],input[name="checkout"]';
    const rows=()=>Array.from(document.querySelectorAll('tr.cart-item,.cart-sidebar__item'));
    function namedRow(row){return Array.from(row.querySelectorAll('a[href]')).some(a=>/\/products\/personalised-guest-name-place-settings-/.test(a.pathname));}
    function decorate(){
      rows().forEach(row=>{
        if(!namedRow(row))return;row.classList.add('wbpn-name-line');
        row.querySelectorAll('quantity-input').forEach(control=>{
          if(control.dataset.wbpnOwned)return;
          const input=control.querySelector('input'),qty=input?Number(input.value):0;
          control.dataset.wbpnOwned='true';
          const label=document.createElement('strong');label.textContent=qty+' names';
          const keep=input&&input.name==='updates[]'?document.createElement('input'):null;
          if(keep){keep.type='hidden';keep.name='updates[]';keep.value=String(qty);}
          control.replaceChildren(label);if(keep)control.append(keep);
          const note=document.createElement('p');note.className='wbpn-cart-help';
          note.textContent='Quantity is linked to your guest list. To change it, remove this list and enter a replacement.';control.append(note);
        });
        // Remove the old expandable hundred-name drawer, including after section refreshes.
        row.querySelectorAll('[data-wbpn-guest-detail]').forEach(el=>el.remove());
      });
    }
    function compact(item){
      const p=item.properties||{},material=(item.options_with_values||[]).find(o=>o.name==='Material and Finish');
      const fields=[['Material / finish',material?material.value:p['Material / finish']],['Name size',p['Name size']],['Guest list',core.names(core.itemNames(item)).length?'Supplied':'Missing — return to the product page']];
      const targets=[document.getElementById('CartItem-'+item.line),document.querySelector('.cart-sidebar__item[data-line="'+item.line+'"]')];
      targets.forEach(row=>{
        if(!row||!namedRow(row))return;
        let dl=row.querySelector('.cart-item__details > dl')||row.querySelector('[data-wbpn-compact]');
        if(!dl){dl=document.createElement('dl');(row.querySelector('.cart-item__title')||row.querySelector('.cart-item__name')).insertAdjacentElement('afterend',dl);}
        dl.dataset.wbpnOwned='true';dl.dataset.wbpnCompact='true';
        const signature=JSON.stringify(fields);
        if(dl.dataset.wbpnSummary!==signature){
          dl.replaceChildren();dl.dataset.wbpnSummary=signature;
          fields.forEach(([label,value])=>{
            if(!value)return;
            const pair=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');
            pair.className='product-option';dt.textContent=label+':';dd.textContent=value;pair.append(dt,dd);dl.append(pair);
          });
        }
        // The compact summary replaces duplicated variant bands and internal confirmation text.
        const options=row.querySelector('.cart-item__options');if(options)options.hidden=true;
      });
    }
    function message(text){
      document.querySelectorAll('#main-cart-footer .cart__footer,#cart-sidebar-footer').forEach(host=>{
        let box=host.querySelector('[data-wbpn-cart-message]');if(!text){if(box)box.remove();return;}
        if(!box){box=document.createElement('p');box.dataset.wbpnCartMessage='true';box.dataset.wbpnOwned='true';box.className='wbpn-cart-alert';box.setAttribute('role','status');box.setAttribute('aria-live','polite');host.prepend(box);}
        if(box.textContent!==text)box.textContent=text;
      });
    }
    function render(){
      decorate();
      const result=core.cartCheck(cart),has=result.items.length>0||rows().some(namedRow);
      document.documentElement.classList.toggle('wbpn-has-lists',has);document.documentElement.classList.add('wbpn-guard-ready');
      const blocked=has&&(!cfg.enabled||!result.ok||Boolean(lastError));
      document.querySelectorAll(checkouts).forEach(button=>{
        if(blocked||(has&&busy)){
          if(button.dataset.wbpnPriorDisabled===undefined)button.dataset.wbpnPriorDisabled=String(button.disabled);button.disabled=true;
        }else if(button.dataset.wbpnPriorDisabled!==undefined){button.disabled=button.dataset.wbpnPriorDisabled==='true';delete button.dataset.wbpnPriorDisabled;}
      });
      message(!has?'':lastError||(!result.ok?'Please correct your place-name list before checkout. '+result.issues.map(i=>i.reason).join(' '):!cfg.enabled?'Place-name ordering is still in review. Checkout for these items will open after final checks.':'Your guest list is supplied; the quantity is checked automatically.'));
      result.items.forEach(compact);return result;
    }
    async function readCart(){
      const controller=new AbortController(),t=setTimeout(()=>controller.abort(),12000);
      try{
        const response=await fetch(cfg.root+'cart.js',{cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal});
        if(!response.ok)throw new Error('Cart check failed');const data=await response.json();
        if(!Array.isArray(data.items))throw new Error('Invalid cart response');cart=data;lastError='';return render();
      }catch(e){lastError='The guest-list check could not be completed. Refresh your cart before checking out.';render();throw e;}finally{clearTimeout(t);}
    }
    async function validateThenContinue(form,submitter,url){
      if(busy)return;busy=true;render();
      try{
        const result=await readCart();if(!result.ok||(result.items.length&&!cfg.enabled))return;
        busy=false;render();
        if(form){passes.add(form);form.requestSubmit(submitter&&submitter.form===form?submitter:undefined);}
        else window.location.assign(url||cfg.root+'checkout');
      }catch(_){/* Stay on the cart with a visible explanation. */}finally{busy=false;render();}
    }
    function hasNames(){return core.cartCheck(cart).items.length>0||rows().some(namedRow);}
    document.addEventListener('click',event=>{
      const target=event.target.closest('button,input,a');if(!target||!hasNames())return;
      if(!target.matches(checkouts)&&!(target.tagName==='A'&&/\/checkout(?:\/|$)/.test(target.pathname)))return;
      event.preventDefault();event.stopImmediatePropagation();validateThenContinue(target.form||null,target,target.href);
    },true);
    document.addEventListener('submit',event=>{
      const form=event.target;if(passes.has(form)){passes.delete(form);return;}if(!hasNames())return;
      const action=new URL(form.action,location.href).pathname;if(!/\/cart$/.test(action)&&!/\/checkout(?:\/|$)/.test(action))return;
      event.preventDefault();event.stopImmediatePropagation();validateThenContinue(form,event.submitter,null);
    },true);
    ['input','change'].forEach(type=>document.addEventListener(type,event=>{
      if(event.target.closest('.wbpn-name-line quantity-input')){event.preventDefault();event.stopImmediatePropagation();decorate();}
    },true));
    new MutationObserver(mutations=>{
      if(!mutations.some(m=>m.target.nodeType===1&&!m.target.closest('[data-wbpn-owned]')&&m.target.closest('#main-cart-items,#main-cart-footer,#cart-sidebar-items,#cart-sidebar-footer')))return;
      decorate();clearTimeout(timer);timer=setTimeout(()=>{if(hasNames()&&!busy)readCart().catch(()=>{});else render();},250);
    }).observe(document.body,{childList:true,subtree:true});
    render();if(hasNames())readCart().catch(()=>{});
    window.addEventListener('pageshow',e=>{if(e.persisted&&hasNames())readCart().catch(()=>{});});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
